import React, {useContext, useEffect, useState} from 'react';
import '../../styles/filterpanel.css';
import {
    MDBCard,
    MDBCardBody,
    MDBFooter,
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import {Button} from "semantic-ui-react";
import Modal from 'react-bootstrap/Modal';
import {ExportModal} from "./ExportModalComponent";
import DateFields from "./DateFieldsComponents";
import {ViewContext} from "../Context/ViewContext";
import {useFilterDatesContext} from "../Context/FilterDatesContext";
import {useFilterDataContext} from "../Context/FilterDataContext";
import KpiService from "../Services/Bll/KpiService";
import Accordion from "@mui/material/Accordion";
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import {MoreFiltersComponent} from "./MoreFiltersComponent";
import {Box, InputLabel} from "@mui/material";

export const FilterPanel = ({onKpiUpdate, isMobile, onLoadingPage}) => {
    const {filteredData} = useFilterDataContext();
    const {dates, setErrors} = useFilterDatesContext();
    const { setView } = useContext(ViewContext);
    const [showExport, setShowExport] = useState(false);
    const handleCloseExport = () => setShowExport(false);
    const handleShowExport = () => setShowExport(true);
    const [showFilters, setShowFilters] = useState(false);
    const [margin, setMargin] = useState("NET");
    const [dateRef, setDateRef] = useState("depart");
    const handleChangeMargin = (event) => {
        setMargin(event.target.value);
    };
    const handleChangeDateRef = (event) => {
        setDateRef(event.target.value);
    };

    const isMargeRoute = location.pathname.includes('marge');
    const isCARoute = location.pathname.includes('ca_detail');

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    useEffect(() => {
        const {newErrors} = KpiService.checkHasValideDate(dates)
        setErrors(newErrors);
    }, [dates]);

    const renderFilterSummary = () => {
        const activeFilters = filteredData ? Object.entries(filteredData)
            .map(([key]) => key.replace("Data", "")) : [];
        if (!activeFilters.length) return null;
        return (
            <div className="filter-summary" style={{
                marginTop: "1rem",
                padding: "0.5rem",
                border: "1px solid #ccc",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9"
            }}>
                <strong>Filtres actifs :</strong> {activeFilters.join(", ")}
            </div>);
    };
    const handleSubmit = async () => {
        const kpiService = new KpiService();
        const {isAllValid, newErrors} = KpiService.checkHasValideDate(dates)
        setErrors(newErrors);

        if (!isAllValid) {
            return;
        }
        onLoadingPage(true);

        try {
            const page = location.pathname;
            const queryParameters = {
                dates,
                filteredData: {
                    ...filteredData,
                    ...(isMargeRoute && {marginData: {margin}}),
                    ...(isCARoute && {dateRefData: {dateRef}}),
                    ...(isMobile && {mobileData: {mobile: true}})
                },
                shouldCapitalize: true
            };
            const query = KpiService.getFilterQuery(queryParameters)
            const kpi = await kpiService.getKPIReport(page, query);
            if (kpi) {
                if(filteredData.comparisonField){
                    const comparisonField = filteredData.comparisonField;
                    const filteredDataComparison = filteredData[`${comparisonField}Data`][`${comparisonField}`]
                       kpi.data.forEach((kpi)=>{
                           const filteredData = filteredDataComparison.find((data)=> data.value === kpi.value);
                           let key = page.replace('/', '');
                           if (filteredData) {
                               if (!kpi[key]) {
                                   kpi[key] = {};
                               }
                               kpi[key].label = filteredData?.label;
                           }
                       })
                }
                kpi.data.dateRef = dateRef;
                onKpiUpdate(kpi.data);
            }
            setView(query.includes('ComparisonField') ? 'double' : 'simple');
            onLoadingPage(false)
        } catch (error) {
            console.error("Erreur:", error);
            alert("Échec lors de la récupération des données");
        }
    };

    return (
        <>
            <MDBCard className="filterPanel h-auto mx-vh-25 col-sm-6 col-md-10 col-lg-11">
                <MDBCardBody className={`${!isMobile ? 'mb-3' : ''} mx-2`}>
                    <MDBRow className="d-flex justify-content-center">
                        <MDBCol xxl={4} xl={5} sm={12}>
                            <DateFields/>
                        </MDBCol>
                        <MDBCol xs={6} lg={6}>
                            <MDBRow>
                                <MDBCol lg={2} md={12} className="text-lg-end" style={{paddingRight: 0}}>
                                    {isMargeRoute && (<InputLabel variant="standard" htmlFor="uncontrolled-native">
                                            Marge
                                        </InputLabel>
                                    )
                                    }
                                    {isCARoute && (<InputLabel variant="standard" htmlFor="uncontrolled-native">
                                            Dates de référence
                                        </InputLabel>
                                    )
                                    }
                                </MDBCol>
                                <MDBCol lg={1} md={12}>
                                    {isMargeRoute && (<select
                                        value={margin}
                                        onChange={handleChangeMargin}
                                        style={{width: '70px', padding: '5px'}}
                                    >
                                        <option value={"NET"}>NET</option>
                                        <option value={"BRUT"}>BRUT</option>
                                    </select>)}
                                    {isCARoute && (<select
                                        value={dateRef}
                                        onChange={handleChangeDateRef}
                                        style={{width: '80px', padding: '5px'}}
                                    >
                                        <option value={"creation"}>création</option>
                                        <option value={"depart"}>départ</option>
                                    </select>)}
                                </MDBCol>
                                <MDBCol lg={3} md={12} className="d-flex justify-content-end">
                                <Box sx={{
                                        marginTop: {lg: 0, sm: '20px', xs: 2},
                                        marginBottom: {xs: 2, md: 0},
                                        width: {lg: '80%', xs: '100%'}
                                    }}>
                                        <Button onClick={handleSubmit}>
                                            Valider
                                        </Button>
                                    </Box>
                                </MDBCol>
                                {!isMobile && <MDBCol lg={3} sm={12}>
                                    <Box sx={{marginBottom: {xs: 2, md: 0}, width: '100%'}}>
                                        <Button onClick={toggleFilters}>
                                            Plus de filtres
                                        </Button>
                                        {renderFilterSummary()}
                                    </Box>
                                </MDBCol>}
                                {!isMobile && <MDBCol lg={3}>
                                    <Button onClick={handleShowExport}>
                                        Export
                                    </Button>
                                </MDBCol>}
                            </MDBRow>
                        </MDBCol>
                    </MDBRow>
                </MDBCardBody>
                {isMobile ? (
                    <Accordion className="h-auto border-danger">
                        <AccordionSummary
                            sx={{border: 1, borderColor: 'grey.500'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            Plus de Filtre
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                                <MoreFiltersComponent/>
                            </div>

                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <MDBFooter className="filtersSelection" style={{display: showFilters ? 'block' : 'none'}}>
                        <MoreFiltersComponent/>
                    </MDBFooter>
                )}
            </MDBCard>

            <Modal className="modalExport modal-xl" show={showExport} onHide={handleCloseExport}>
                <ExportModal/>
            </Modal>
        </>
    );
}
